// /Users/caffas/Documents/Sistemas/vsadmin/admin/admin-app/src/authProvider.js

//const API_URL = 'https://98fzfcf5hk.execute-api.eu-west-3.amazonaws.com/v2'; 

// Cambiar la definición de API_URL para que dependa del entorno
const API_URL = window.location.hostname === 'localhost' 
    ? 'http://localhost:3000' 
    : 'https://98fzfcf5hk.execute-api.eu-west-3.amazonaws.com/v2';

export const authProvider = {
    
    login: async ({ username, password }) => {
        const email = username;
        console.log('🔐 AuthProvider: login called', { email });

        try {
            const response = await fetch(`${API_URL}/Login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email, password }),
            });
            
            const result = await response.json();
            console.log('🔐 AuthProvider: login response', result);

            if (result.statusCode !== 200) {
                console.log('🔐 AuthProvider: login failed - invalid credentials');
                throw new Error('Credenciales inválidas');
            }
            
            if (result.success) {
                if(result.nivel === 999){
                    const token = result.token_vr;
                    const email = result.email;
                    
                    // ✅ Verificar que los datos existan antes de guardar
                    console.log('🔐 AuthProvider: About to store data', { 
                        hasToken: !!token, 
                        hasEmail: !!email,
                        tokenLength: token ? token.length : 0,
                        tokenValue: token, // ✅ Ver el valor real
                        emailValue: email, // ✅ Ver el valor real
                        resultKeys: Object.keys(result),
                        fullResult: result // ✅ Ver toda la respuesta
                    });
                    
                    // ✅ Verificar que token no sea undefined/null
                    if (!token) {
                        console.error('🚨 AuthProvider: CRITICAL - token is null/undefined!');
                        return Promise.reject('Token not received from server');
                    }
                    
                    // Guardamos el token y la información del usuario
                    localStorage.setItem('token', token);
                    localStorage.setItem('email', email);
                    localStorage.setItem('userAccount', JSON.stringify(result));
                    
                    // ✅ Verificar inmediatamente después de guardar
                    const storedToken = localStorage.getItem('token');
                    const storedEmail = localStorage.getItem('email');
                    const storedUserAccount = localStorage.getItem('userAccount');
                    
                    console.log('🔐 AuthProvider: Data stored, immediate verification', {
                        storedToken: !!storedToken,
                        storedEmail: !!storedEmail,
                        storedUserAccount: !!storedUserAccount,
                        tokenMatch: storedToken === token,
                        emailMatch: storedEmail === email,
                        storedTokenValue: storedToken,
                        storedEmailValue: storedEmail
                    });
                    
                    // ✅ Verificar que localStorage funcione correctamente
                    if (!storedToken || !storedUserAccount) {
                        console.error('🚨 AuthProvider: CRITICAL - localStorage failed to store data!');
                        console.error('🚨 AuthProvider: localStorage support:', typeof(Storage) !== "undefined");
                        return Promise.reject('Failed to store authentication data');
                    }
                    
                    console.log('🔐 AuthProvider: login successful, data stored and verified');
                } else {
                    console.log('🔐 AuthProvider: login failed - invalid admin access');
                    return Promise.reject("Invalid Admin access");
                }
            }
            console.log('🔐 AuthProvider: login completed successfully');
            return Promise.resolve();
        } catch (error) {
            console.log('🔐 AuthProvider: login error', error.message);
            return Promise.reject(error.message);
        }
    },

    logout: () => {
        console.log('🚨 AuthProvider: logout called');
        console.trace('🚨 AuthProvider: logout stack trace');
        
        // ✅ Verificar qué hay en localStorage antes de limpiar
        console.log('🚨 AuthProvider: localStorage before cleanup', {
            hasToken: !!localStorage.getItem('token'),
            hasEmail: !!localStorage.getItem('email'),
            hasUserAccount: !!localStorage.getItem('userAccount')
        });
        
        localStorage.removeItem('token');
        localStorage.removeItem('email'); 
        localStorage.removeItem('userAccount');
        console.log('🔐 AuthProvider: logout completed, localStorage cleared');
        return Promise.resolve();
    },

    checkError: (error) => {
        console.log('🔐 AuthProvider: checkError called', error);
        const status = error.status;
        if (status === 401 || status === 403) {
            console.log('🚨 AuthProvider: checkError triggering logout due to', status);
            localStorage.removeItem('token');
            localStorage.removeItem('email');
            localStorage.removeItem('userAccount');
            return Promise.reject();
        }
        return Promise.resolve();
    },

    checkAuth: () => {
        console.log('🔐 AuthProvider: checkAuth called - checking localStorage...');
        
        const token = localStorage.getItem('token');
        const userAccount = localStorage.getItem('userAccount');
        const email = localStorage.getItem('email');
        
        // ✅ Log más detallado
        console.log('🔐 AuthProvider: checkAuth localStorage contents', { 
            hasToken: !!token, 
            hasUserAccount: !!userAccount,
            hasEmail: !!email,
            tokenLength: token ? token.length : 0,
            userAccountLength: userAccount ? userAccount.length : 0,
            allLocalStorageKeys: Object.keys(localStorage),
            tokenValue: token,
            userAccountValue: userAccount
        });
        
        // ✅ Verificar tanto token como userAccount
        if (!token || !userAccount) {
            console.log('🚨 AuthProvider: checkAuth failed - missing token or userAccount');
            console.log('🚨 AuthProvider: Missing items:', {
                missingToken: !token,
                missingUserAccount: !userAccount
            });
            return Promise.reject('No authentication data');
        }
        
        // ✅ Verificar que userAccount sea válido JSON
        try {
            const parsedAccount = JSON.parse(userAccount);
            console.log('🔐 AuthProvider: Parsed userAccount', {
                hasNivel: !!parsedAccount.nivel,
                nivel: parsedAccount.nivel,
                isValidLevel: parsedAccount.nivel === 999
            });
            
            if (!parsedAccount.nivel || parsedAccount.nivel !== 999) {
                console.log('🚨 AuthProvider: checkAuth failed - invalid user level');
                return Promise.reject('Invalid user level');
            }
        } catch (error) {
            console.log('🚨 AuthProvider: checkAuth failed - invalid userAccount JSON', error);
            return Promise.reject('Invalid user data');
        }
        
        console.log('✅ AuthProvider: checkAuth successful');
        return Promise.resolve();
    },

    getPermissions: () => {
        console.log('🔐 AuthProvider: getPermissions called');
        
        // ✅ Verificar localStorage completo cuando se llama getPermissions
        console.log('🔐 AuthProvider: getPermissions localStorage check', {
            allKeys: Object.keys(localStorage),
            hasToken: !!localStorage.getItem('token'),
            hasEmail: !!localStorage.getItem('email'),
            hasUserAccount: !!localStorage.getItem('userAccount'),
            tokenValue: localStorage.getItem('token'),
            userAccountValue: localStorage.getItem('userAccount')
        });
        
        try {
            const userAccountStr = localStorage.getItem('userAccount');
            if (!userAccountStr) {
                console.log('🚨 AuthProvider: getPermissions - no userAccount found');
                console.log('🚨 AuthProvider: getPermissions - localStorage dump:', {
                    allItems: Object.keys(localStorage).reduce((acc, key) => {
                        acc[key] = localStorage.getItem(key);
                        return acc;
                    }, {})
                });
                return Promise.resolve([]);
            }
            
            const userAccount = JSON.parse(userAccountStr);
            const permissions = userAccount.nivel ? [userAccount.nivel] : [];
            console.log('🔐 AuthProvider: getPermissions result', permissions);
            return Promise.resolve(permissions);
        } catch (error) {
            console.error('🚨 AuthProvider: getPermissions error', error);
            return Promise.resolve([]);
        }
    },

    getIdentity: () => {
        console.log('🔐 AuthProvider: getIdentity called');
        
        // ✅ Verificar localStorage cuando se llama getIdentity
        console.log('🔐 AuthProvider: getIdentity localStorage check', {
            hasUserAccount: !!localStorage.getItem('userAccount'),
            userAccountValue: localStorage.getItem('userAccount')
        });
        
        try {
            const userAccountStr = localStorage.getItem('userAccount');
            if (!userAccountStr) {
                console.log('🚨 AuthProvider: getIdentity - no userAccount found');
                return Promise.resolve({
                    id: 'unknown',
                    fullName: 'Usuario',
                    avatar: null,
                });
            }
            
            const userAccount = JSON.parse(userAccountStr);
            const identity = {
                id: userAccount.id || userAccount.email || 'unknown',
                fullName: userAccount.name || userAccount.email || 'Usuario',
                avatar: userAccount.avatar || null,
            };
            console.log('🔐 AuthProvider: getIdentity result', identity);
            return Promise.resolve(identity);
        } catch (error) {
            console.error('🚨 AuthProvider: getIdentity error', error);
            return Promise.resolve({
                id: 'unknown',
                fullName: 'Usuario',
                avatar: null,
            });
        }
    }
};